import script from "./lead.vue?vue&type=script&setup=true&lang=js"
export * from "./lead.vue?vue&type=script&setup=true&lang=js"

import "./lead.vue?vue&type=style&index=0&id=39ec91c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ec91c2"]])

export default __exports__